import { useEffect } from "react";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Backdrop, Snackbar, Alert } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

import { RegisterComponent } from "./components/register";
import { DashboardComponent } from "./components/dashboard";
import { AuthComponent } from "./components/auth";
import { LoginComponent } from "./components/login";
import { AttendanceComponent } from "./components/attendance";
import { ClearComponent } from "./components/clear";
import { AttendanceParamsComponent } from "./components/attendance-params";

import { useAppSelector, useAppDispatch } from "./redux/hooks";
import { getApp, message, backdrop } from "./redux/app.slice";

function App() {
  const app = useAppSelector(getApp);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(backdrop(false));
  }, [dispatch]);

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={app.backdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={app.message.open}
        autoHideDuration={6000}
        onClose={() => dispatch(message({ open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={app.message.severity}>{app.message.message}</Alert>
      </Snackbar>
      <BrowserRouter>
        <Routes>
          <Route path="/">
            <Route index element={<LoginComponent />} />
            <Route path="clear">
              <Route path=":timestamp" element={<ClearComponent />} />
            </Route>
            <Route path="register" element={<RegisterComponent />} />
            <Route path="auth">
              <Route
                path=":id/:secret/:country/:phone"
                element={<AuthComponent />}
              ></Route>
            </Route>
            <Route path="dashboard">
              <Route index element={<DashboardComponent />} />
              <Route path="attendance">
                <Route index element={<AttendanceComponent />} />
                <Route path=":method" element={<AttendanceParamsComponent />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
